import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'servicio a la habitación',
      [RoomServiceLocationType.TableService]: 'servicio en mesa',
    },
    [ORDER_METHODS.PICKUP]: 'recogida',
    [ORDER_METHODS.DELIVERY]: 'entrega',
  },
  errors: {
    draft_validation_failed: 'Por favor, completa tu dirección de entrega antes de continuar.',
  },
};
